/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type Address = {
  /** Name of city or city district (ex. København K) */
  city: Scalars['String'];
  /** Residence door if building or floor has multiple doors (ex. TH) */
  door?: Maybe<Scalars['String']>;
  /** Residence floor if building has multiple floors (ex. 1.) */
  floor?: Maybe<Scalars['String']>;
  /** House number on street (ex. 24A) */
  houseNumber: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  /** City postal code (ex. 2800) */
  postalCode: Scalars['String'];
  /** Name of street without house number (ex. Vesterbrogade) */
  street: Scalars['String'];
};

export type AddressInput = {
  /** Name of city or city district (ex. København K) */
  city: Scalars['String'];
  /** Residence door if building or floor has multiple doors (ex. TH) */
  door?: InputMaybe<Scalars['String']>;
  /** Residence floor if building has multiple floors (ex. 1.) */
  floor?: InputMaybe<Scalars['String']>;
  /** House number on street (ex. 24A) */
  houseNumber: Scalars['String'];
  /** City postal code (ex. 2800) */
  postalCode: Scalars['String'];
  /** Name of street without house number (ex. Vesterbrogade) */
  street: Scalars['String'];
};

export type AllOfferSavings = {
  disclaimer: Scalars['String'];
  residence?: Maybe<SimpleResidenceResult>;
  results: Array<OfferSavingsWithProducts>;
};

export type AssortedOfferInput = {
  assortedProducts: Array<ProductInput>;
  discount?: InputMaybe<Scalars['Int']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Int']>;
  expenses?: InputMaybe<Array<OfferExpenseInput>>;
  notes?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<Scalars['String']>;
  withoutInstallation?: InputMaybe<Scalars['Boolean']>;
};

export type AssortedProduct = {
  brand: Scalars['String'];
  buyPrice?: Maybe<Scalars['Float']>;
  datasheetUrl?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Float']>;
  descriptionId?: Maybe<Scalars['Int']>;
  id: Scalars['Float'];
  imageUrl?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  offerID?: Maybe<Scalars['Float']>;
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Float']>;
  size: HeatPumpSize;
};

export type AssortedProductInput = {
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String'];
  buyPrice?: InputMaybe<Scalars['Float']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['Float']>;
  descriptionId?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  model: Scalars['String'];
  price: Scalars['Float'];
};

export type AuthProvider = {
  type: AuthProviderType;
  userID: Scalars['String'];
};

export type AuthProviderType =
  | 'google';

export type BankCustomerLead = {
  address: AddressInput;
  /** Bank branch at which customer advisor works */
  advisorBranch?: InputMaybe<Scalars['String']>;
  /** Email of advisor assigned to customer */
  advisorEmail?: InputMaybe<Scalars['String']>;
  /** Name of advisor assigned to customer */
  advisorName?: InputMaybe<Scalars['String']>;
  /** Any comments that might be relevant */
  comments?: InputMaybe<Scalars['String']>;
  desiredProducts?: InputMaybe<Array<LeadProductTypeEnum>>;
  /** Customer email address */
  email: Scalars['String'];
  /** Given first name(s) */
  firstName: Scalars['String'];
  /** Legal surname */
  lastName: Scalars['String'];
  /** Phone number including country code (+45) */
  phoneNumber: Scalars['String'];
  /** Universally unique lead identifier */
  uuid: Scalars['String'];
};

export type Battery = {
  brand: Scalars['String'];
  buyPrice?: Maybe<Scalars['Float']>;
  capacity: Scalars['Float'];
  customerEnabled?: Maybe<Scalars['Boolean']>;
  datasheetUrl?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Float']>;
  descriptionId?: Maybe<Scalars['Int']>;
  efficiency: Scalars['Float'];
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  imageUrl?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  offerID?: Maybe<Scalars['Float']>;
  preferred?: Maybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Int']>;
  size: HeatPumpSize;
  warrantyCycles?: Maybe<Scalars['Int']>;
  warrantyYears?: Maybe<Scalars['Int']>;
  webshopEnabled?: Maybe<Scalars['Boolean']>;
  weight: Scalars['Float'];
};

export type BatteryInput = {
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String'];
  buyPrice?: InputMaybe<Scalars['Float']>;
  capacity: Scalars['Float'];
  customerEnabled?: InputMaybe<Scalars['Boolean']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['Float']>;
  descriptionId?: InputMaybe<Scalars['Int']>;
  efficiency: Scalars['Float'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  model: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  warrantyCycles?: InputMaybe<Scalars['Int']>;
  warrantyYears?: InputMaybe<Scalars['Int']>;
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
  weight: Scalars['Float'];
};

export type BatteryProductRange = {
  batteries: Array<Battery>;
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type BatteryRangeInput = {
  batteryIDs: Array<Scalars['Int']>;
  title: Scalars['String'];
};

export type BbrPrimaryHeating = {
  annualUsage: Scalars['Float'];
  efficiency?: Maybe<Scalars['Float']>;
  fuelSubtype?: Maybe<Scalars['String']>;
  fuelType: Scalars['String'];
  heatSource?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  volumeUnit?: Maybe<Scalars['String']>;
};

export type BbrResidence = {
  area: Scalars['Float'];
  areaHeated: Scalars['Float'];
  areaNotHeated?: Maybe<Scalars['Int']>;
  areaPartiallyHeated?: Maybe<Scalars['Float']>;
  builtYear?: Maybe<Scalars['Float']>;
  consumption?: Maybe<Consumption>;
  energyExpenditure: Scalars['Float'];
  energyLabel?: Maybe<EnergyLabelEnum>;
  floors: Scalars['Float'];
  heatDistribution?: Maybe<HeatDistributionTypeEnum>;
  id?: Maybe<Scalars['Int']>;
  primaryHeating?: Maybe<BbrPrimaryHeating>;
  renovatedDegree?: Maybe<RenovationDegreeEnum>;
  renovatedYear?: Maybe<Scalars['Float']>;
  residents?: Maybe<Scalars['Float']>;
  roofs?: Maybe<Array<Roof>>;
  secondaryHeating?: Maybe<BbrSecondaryHeating>;
  type: ResidenceType;
  waterConsumption: WaterConsumptionDegreeEnum;
};

export type BbrSecondaryHeating = {
  heatSource?: Maybe<Scalars['String']>;
};

export type BoxSize = {
  depth: Scalars['Float'];
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type BoxSizeInput = {
  depth: Scalars['Float'];
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type CrmCustomer = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type CrmCustomerFields = {
  address?: Maybe<Scalars['String']>;
  assignedAdvisor?: Maybe<Scalars['String']>;
  financialAdvisor?: Maybe<Scalars['String']>;
  leadOrigin?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};

export type CompositeFigure = {
  floor: Scalars['Float'];
  radiator: Scalars['Float'];
};

export type CompositeLabel = {
  floor: Scalars['String'];
  radiator: Scalars['String'];
};

export type Constant = {
  code: Scalars['String'];
  denominator?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  numerator: Scalars['String'];
  valueNumber: Scalars['Float'];
};

export type ConstantInput = {
  code: Scalars['String'];
  denominator?: InputMaybe<Scalars['String']>;
  numerator: Scalars['String'];
  valueNumber: Scalars['Float'];
};

export type Consumption = {
  profileKey: ConsumptionProfile;
  profileValue: Array<Scalars['Float']>;
};

export type ConsumptionProfile =
  | 'homeAt17'
  | 'homeEveryDay'
  | 'homeInAfternoon'
  | 'homeInMorning'
  | 'homeMostDays'
  | 'industrialConsumption';

export type Customer = {
  assignedAdvisor?: Maybe<User>;
  assignedAdvisorId?: Maybe<Scalars['Int']>;
  callBackAt?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Float'];
  eligibleForFinancing: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  financialAdvisor?: Maybe<Scalars['String']>;
  financingProvider?: Maybe<CustomerFinancingProvider>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  includeHeatPumpSubsidy?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  leadOrigin?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  newsletter?: Maybe<Scalars['Boolean']>;
  norlysPromotion?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  numberOfOffers?: Maybe<Scalars['Int']>;
  ownerID?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Float']>;
  usePriceInflation?: Maybe<Scalars['Boolean']>;
};

export type CustomerFinancingProvider =
  | 'jyskebank'
  | 'nordea';

export type CustomerInput = {
  assignedAdvisorId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  financialAdvisor?: InputMaybe<Scalars['String']>;
  financingProvider?: InputMaybe<CustomerFinancingProvider>;
  firstName?: InputMaybe<Scalars['String']>;
  googleClickId?: InputMaybe<Scalars['String']>;
  includeHeatPumpSubsidy?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  leadOrigin?: InputMaybe<Scalars['String']>;
  newsletter?: InputMaybe<Scalars['Boolean']>;
  norlysPromotion?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  scoringFields?: InputMaybe<ScoringFields>;
  usePriceInflation?: InputMaybe<Scalars['Boolean']>;
  utmFields?: InputMaybe<UtmFields>;
};

export type CylinderSize = {
  diameter: Scalars['Float'];
  height: Scalars['Float'];
};

export type CylinderSizeInput = {
  diameter: Scalars['Float'];
  height: Scalars['Float'];
};

export type DataConsentInput = {
  consented: Scalars['Boolean'];
  partner: DataConsentPartner;
};

export type DataConsentPartner =
  | 'edc'
  | 'jyskebank'
  | 'nordea'
  | 'norlys';

export type ElectricCar = {
  annualKilometersDriven: Scalars['Int'];
  consumptionPerKilometer: Scalars['Int'];
  id: Scalars['Int'];
  isSubsidised?: Maybe<Scalars['Boolean']>;
  monthlySubscriptionPrice?: Maybe<Scalars['Float']>;
  percentageCharged: Scalars['Int'];
};

export type ElectricCarInput = {
  annualKilometersDriven: Scalars['Int'];
  consumptionPerKilometer: Scalars['Int'];
  isSubsidised?: InputMaybe<Scalars['Boolean']>;
  monthlySubscriptionPrice?: InputMaybe<Scalars['Float']>;
  percentageCharged: Scalars['Int'];
};

export type EnergyLabelEnum =
  | 'A2010'
  | 'A2015'
  | 'A2020'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G';

export type EnergyLabels = {
  before: Scalars['String'];
  both?: Maybe<Scalars['String']>;
  heatPump?: Maybe<Scalars['String']>;
  solar?: Maybe<Scalars['String']>;
};

export type ExpenseAutomation = {
  condition: Scalars['String'];
  id: Scalars['Int'];
  quantity: Scalars['Int'];
  quantityCondition?: Maybe<Scalars['String']>;
};

export type ExpenseAutomationInput = {
  condition: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantityCondition?: InputMaybe<Scalars['String']>;
};

export type FuelType =
  | 'districtHeating'
  | 'electricity'
  | 'gas'
  | 'oil'
  | 'pallet'
  | 'straw'
  | 'wood';

export type HeatDistributionTypeEnum =
  | 'floor'
  | 'radiator'
  | 'radiatorAndFloor';

export type HeatPumpApp =
  | 'addition'
  | 'nibe'
  | 'unknown'
  | 'yes';

export type HeatPumpIndoorUnit = {
  app: HeatPumpApp;
  brand: Scalars['String'];
  buffer: Scalars['Float'];
  buyPrice?: Maybe<Scalars['Float']>;
  customerEnabled?: Maybe<Scalars['Boolean']>;
  datasheetUrl?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Float']>;
  descriptionId?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  imageUrl?: Maybe<Scalars['String']>;
  internet: HeatPumpInternet;
  model: Scalars['String'];
  noiseLevel: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  offerID?: Maybe<Scalars['Float']>;
  power?: Maybe<Scalars['String']>;
  preferred?: Maybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Int']>;
  size: HeatPumpSize;
  solutionType: IndoorUnitSolutionType;
  waterVolume: Scalars['Float'];
  webshopEnabled?: Maybe<Scalars['Boolean']>;
};

export type HeatPumpIndoorUnitInput = {
  app: HeatPumpApp;
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String'];
  buffer: Scalars['Float'];
  buyPrice?: InputMaybe<Scalars['Float']>;
  customerEnabled?: InputMaybe<Scalars['Boolean']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['Float']>;
  descriptionId?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  internet: HeatPumpInternet;
  model: Scalars['String'];
  noiseLevel: Scalars['Float'];
  notes?: InputMaybe<Scalars['String']>;
  power?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  solutionType?: InputMaybe<IndoorUnitSolutionType>;
  waterVolume: Scalars['Float'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type HeatPumpInternet =
  | 'LAN'
  | 'unknown'
  | 'wifi'
  | 'wifiAddition';

export type HeatPumpOfferInput = {
  chosenHeating?: InputMaybe<Scalars['Float']>;
  discount?: InputMaybe<Scalars['Int']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Int']>;
  expenses?: InputMaybe<Array<OfferExpenseInput>>;
  heatPumpIndoorProduct?: InputMaybe<ProductInput>;
  heatPumpOutdoorProduct?: InputMaybe<ProductInput>;
  notes?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<Scalars['String']>;
  withoutInstallation?: InputMaybe<Scalars['Boolean']>;
};

export type HeatPumpOutdoorUnit = {
  brand: Scalars['String'];
  buyPrice?: Maybe<Scalars['Float']>;
  compatibleIndoorUnits: Array<Scalars['Int']>;
  copHotWater?: Maybe<Scalars['Float']>;
  customerEnabled?: Maybe<Scalars['Boolean']>;
  datasheetUrl?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Float']>;
  descriptionId?: Maybe<Scalars['Int']>;
  effect7: CompositeFigure;
  effect12: CompositeFigure;
  enabled?: Maybe<Scalars['Boolean']>;
  energyLabel: CompositeLabel;
  id: Scalars['Float'];
  imageUrl?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  noiseLevel: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  offerID?: Maybe<Scalars['Float']>;
  preferred?: Maybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Int']>;
  scop: CompositeFigure;
  size: HeatPumpSize;
  temperatureOut: Scalars['Int'];
  waterLabel: Scalars['String'];
  webshopEnabled?: Maybe<Scalars['Boolean']>;
};

export type HeatPumpOutdoorUnitInput = {
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String'];
  buyPrice?: InputMaybe<Scalars['Float']>;
  compatibleIndoorUnits: Array<Scalars['Int']>;
  copHotWater: Scalars['Float'];
  customerEnabled?: InputMaybe<Scalars['Boolean']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['Float']>;
  descriptionId?: InputMaybe<Scalars['Int']>;
  effectFloor7: Scalars['Float'];
  effectFloor12: Scalars['Float'];
  effectRadiator7: Scalars['Float'];
  effectRadiator12: Scalars['Float'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  energyLabelFloor: Scalars['String'];
  energyLabelRadiator: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  model: Scalars['String'];
  noiseLevel: Scalars['Float'];
  notes?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  scopFloor: Scalars['Float'];
  scopRadiator: Scalars['Float'];
  temperatureOut: Scalars['Int'];
  waterLabel: Scalars['String'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type HeatPumpPackageInput = {
  calculatorEnabled?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['Float']>;
  indoorUnitID?: InputMaybe<Scalars['Int']>;
  outdoorUnitID: Scalars['Int'];
  title: Scalars['String'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type HeatPumpProductPackage = {
  calculatorEnabled?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<Scalars['Float']>;
  indoorUnits?: Maybe<Array<HeatPumpIndoorUnit>>;
  outdoorUnits: Array<HeatPumpOutdoorUnit>;
  packageID: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  webshopEnabled?: Maybe<Scalars['Boolean']>;
};

export type HeatPumpSize = BoxSize | CylinderSize;

export type HeatingPriority =
  | 'primary'
  | 'secondary';

export type HeatingSource =
  | 'districtHeating'
  | 'electricity'
  | 'gas'
  | 'heatPump'
  | 'oil'
  | 'other';

export type HouseInput = {
  annualPrice: Scalars['Float'];
  fuelType: FuelType;
};

export type HouseInputWithUsage = {
  annualUsage: Scalars['Float'];
  electricCar?: InputMaybe<ElectricCarInput>;
  energyExpenditure?: InputMaybe<Scalars['Float']>;
  fuelType: FuelType;
};

export type Image = {
  category?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  residenceID?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type IndoorUnitSolutionType =
  | 'mono'
  | 'split';

export type InterestedInAdvice =
  | 'no'
  | 'yes';

export type Inverter = {
  brand: Scalars['String'];
  buyPrice?: Maybe<Scalars['Float']>;
  capacity: Scalars['Float'];
  compatibleBatteries?: Maybe<Array<Scalars['Int']>>;
  customerEnabled?: Maybe<Scalars['Boolean']>;
  datasheetUrl?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Float']>;
  descriptionId?: Maybe<Scalars['Int']>;
  efficiency: Scalars['Float'];
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  imageUrl?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  offerID?: Maybe<Scalars['Float']>;
  preferred?: Maybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Int']>;
  size: HeatPumpSize;
  warrantyYears: Scalars['Int'];
  webshopEnabled?: Maybe<Scalars['Boolean']>;
  weight: Scalars['Float'];
};

export type InverterInput = {
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String'];
  buyPrice?: InputMaybe<Scalars['Float']>;
  capacity: Scalars['Float'];
  compatibleBatteries?: InputMaybe<Array<Scalars['Int']>>;
  customerEnabled?: InputMaybe<Scalars['Boolean']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['Float']>;
  descriptionId?: InputMaybe<Scalars['Int']>;
  efficiency: Scalars['Float'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  model: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  warrantyYears: Scalars['Int'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
  weight: Scalars['Float'];
};

export type InvestmentTime =
  | 'laterThan3Months'
  | 'undecided'
  | 'within3Months';

export type LeadProductTypeEnum =
  | 'heatPump'
  | 'other'
  | 'solar';

export type LoginResult = {
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  user: User;
};

export type MonthlyConsumption = {
  profileKey: MonthlyConsumptionProfile;
  profileValue: Array<Scalars['Float']>;
};

export type MonthlyConsumptionProfile =
  | 'industrial'
  | 'privateDomicile';

export type Mutation = {
  addCustomerLead: Scalars['Boolean'];
  archiveOffer: Scalars['Boolean'];
  callMe: Scalars['Boolean'];
  contactMe: Scalars['Boolean'];
  copyOffer: Offer;
  createBatteryRange: BatteryProductRange;
  createConstant: Constant;
  createHeatPumpPackage: HeatPumpProductPackage;
  createProductDescription: ProductDescription;
  createSolarProductPackage?: Maybe<SolarProductPackage>;
  deleteAssortedProductDatasheet: Scalars['Boolean'];
  deleteBatteryDatasheet: Scalars['Boolean'];
  deleteBatteryRange: Scalars['Boolean'];
  deleteElectricCar: Scalars['Boolean'];
  deleteExpenseTemplate: Scalars['Boolean'];
  deleteHeatPumpIndoorUnitDatasheet: Scalars['Boolean'];
  deleteHeatPumpOutdoorUnitDatasheet: Scalars['Boolean'];
  deleteHeatPumpPackage: Scalars['Boolean'];
  deleteInverterDatasheet: Scalars['Boolean'];
  deleteOfferExpenses: Scalars['Boolean'];
  deleteProductDescription: Scalars['Boolean'];
  deleteResidenceImage: Scalars['Boolean'];
  deleteSiteVisitFile: Scalars['Boolean'];
  deleteSolarPanelDatasheet: Scalars['Boolean'];
  deleteSolarProductPackage: Scalars['Boolean'];
  forgotPassword: Scalars['String'];
  hardDeleteCustomer: Scalars['Boolean'];
  insertAndSendOffers: Scalars['Boolean'];
  insertAndSendOffersExternal: Scalars['Boolean'];
  insertAssortedProduct?: Maybe<AssortedProduct>;
  insertBattery?: Maybe<Battery>;
  insertHeatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  insertHeatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  insertInverter?: Maybe<Inverter>;
  insertOffers: Array<Offer>;
  insertSolarPanel?: Maybe<SolarPanel>;
  login: LoginResult;
  logout: Scalars['Boolean'];
  markOfferAsSent: Scalars['Boolean'];
  refreshLogin: LoginResult;
  regeneratePreview: Scalars['String'];
  register: User;
  registerLead: Scalars['Boolean'];
  removeConstant: Scalars['Boolean'];
  resendVerificationEmail: Scalars['String'];
  setOfferExpenses: Array<OfferExpense>;
  setResidenceRoofType: Scalars['Boolean'];
  syncContactInformationWithCRM: Scalars['Boolean'];
  syncOfferExpenses: Offer;
  syncOfferInformationWithCRM: Scalars['Boolean'];
  syncProductsWithWebshop: Scalars['Boolean'];
  unarchiveOffer: Scalars['Boolean'];
  unregister: Scalars['Boolean'];
  updateAssortedProduct?: Maybe<AssortedProduct>;
  updateAssortedProductImage: Scalars['String'];
  updateBattery?: Maybe<Battery>;
  updateBatteryImage: Scalars['String'];
  updateBatteryRange: BatteryProductRange;
  updateConstant: Constant;
  updateContactScoringFields?: Maybe<Scalars['Boolean']>;
  updateHeatPumpIndoorImage: Scalars['String'];
  updateHeatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  updateHeatPumpOutdoorImage: Scalars['String'];
  updateHeatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  updateHeatPumpPackage: HeatPumpProductPackage;
  updateInverter?: Maybe<Inverter>;
  updateInverterImage: Scalars['String'];
  updateOfferNotes: Offer;
  updateOfferProductPrice: Offer;
  updatePassword: Scalars['Boolean'];
  updateProductDescription: ProductDescription;
  updateSolarPanel?: Maybe<SolarPanel>;
  updateSolarPanelImage: Scalars['String'];
  updateSolarProductPackage?: Maybe<SolarProductPackage>;
  updateUser?: Maybe<User>;
  uploadAssortedProductDatasheet: Scalars['Boolean'];
  uploadBatteryDatasheet: Scalars['Boolean'];
  uploadHeatPumpIndoorUnitDatasheet: Scalars['Boolean'];
  uploadHeatPumpOutdoorUnitDatasheet: Scalars['Boolean'];
  uploadInverterDatasheet: Scalars['Boolean'];
  uploadPublicFile: Scalars['String'];
  uploadResidenceImages: Array<Image>;
  uploadSiteVisitFile: Scalars['String'];
  uploadSolarPanelDatasheet: Scalars['Boolean'];
  upsertCustomer: Customer;
  upsertExpenseTemplate: OfferExpenseTemplate;
  upsertReservation: Offer;
  upsertResidence: Residence;
  upsertSiteVisitAnswerList: Scalars['Boolean'];
};


export type MutationAddCustomerLeadArgs = {
  customer: BankCustomerLead;
};


export type MutationArchiveOfferArgs = {
  id: Scalars['Int'];
};


export type MutationCallMeArgs = {
  address?: InputMaybe<Scalars['String']>;
  leadOrigin?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationContactMeArgs = {
  email: Scalars['String'];
  inquiry?: InputMaybe<Scalars['String']>;
  isCompany?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type MutationCopyOfferArgs = {
  archiveExisting?: InputMaybe<Scalars['Boolean']>;
  existingOfferID: Scalars['Int'];
  offer: OfferInput;
};


export type MutationCreateBatteryRangeArgs = {
  batteryRangeInput: BatteryRangeInput;
};


export type MutationCreateConstantArgs = {
  constant: ConstantInput;
};


export type MutationCreateHeatPumpPackageArgs = {
  heatPumpPackageInput?: InputMaybe<HeatPumpPackageInput>;
};


export type MutationCreateProductDescriptionArgs = {
  description: ProductDescriptionInput;
};


export type MutationCreateSolarProductPackageArgs = {
  solarPackageInput?: InputMaybe<SolarProductPackageInput>;
};


export type MutationDeleteAssortedProductDatasheetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteBatteryDatasheetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteBatteryRangeArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteElectricCarArgs = {
  residenceID: Scalars['Int'];
};


export type MutationDeleteExpenseTemplateArgs = {
  templateID: Scalars['Int'];
};


export type MutationDeleteHeatPumpIndoorUnitDatasheetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteHeatPumpOutdoorUnitDatasheetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteHeatPumpPackageArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteInverterDatasheetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteOfferExpensesArgs = {
  expenseIds: Array<Scalars['Int']>;
  offerId: Scalars['Int'];
};


export type MutationDeleteProductDescriptionArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteResidenceImageArgs = {
  code?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  residenceID: Scalars['Int'];
};


export type MutationDeleteSiteVisitFileArgs = {
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type MutationDeleteSolarPanelDatasheetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteSolarProductPackageArgs = {
  id: Scalars['Int'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationHardDeleteCustomerArgs = {
  id: Scalars['Int'];
};


export type MutationInsertAndSendOffersArgs = {
  address: AddressInput;
  customer: CustomerInput;
  dataConsent?: InputMaybe<DataConsentInput>;
  heatPumpOffers?: InputMaybe<Array<HeatPumpOfferInput>>;
  residence: ResidenceInput;
  solarOffers?: InputMaybe<Array<SolarOfferInput>>;
};


export type MutationInsertAndSendOffersExternalArgs = {
  address: AddressInput;
  customer: PartnerCustomerInput;
  dataConsent?: InputMaybe<DataConsentInput>;
  heatPumpOffers?: InputMaybe<Array<HeatPumpOfferInput>>;
  residence: PartnerResidenceInput;
  solarOffers?: InputMaybe<Array<SolarOfferInput>>;
};


export type MutationInsertAssortedProductArgs = {
  unit: AssortedProductInput;
};


export type MutationInsertBatteryArgs = {
  unit: BatteryInput;
};


export type MutationInsertHeatPumpIndoorUnitArgs = {
  unit: HeatPumpIndoorUnitInput;
};


export type MutationInsertHeatPumpOutdoorUnitArgs = {
  unit: HeatPumpOutdoorUnitInput;
};


export type MutationInsertInverterArgs = {
  unit: InverterInput;
};


export type MutationInsertOffersArgs = {
  address?: InputMaybe<AddressInput>;
  assortedOffers?: InputMaybe<Array<AssortedOfferInput>>;
  customerID?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  heatPumpOffers?: InputMaybe<Array<HeatPumpOfferInput>>;
  residenceID?: InputMaybe<Scalars['Int']>;
  solarOffers?: InputMaybe<Array<SolarOfferInput>>;
};


export type MutationInsertSolarPanelArgs = {
  unit: SolarPanelInput;
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationLogoutArgs = {
  refreshToken: Scalars['String'];
};


export type MutationMarkOfferAsSentArgs = {
  offerID: Scalars['Int'];
  type: OfferPdfTypeEnum;
};


export type MutationRefreshLoginArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRegeneratePreviewArgs = {
  offerID: Scalars['Int'];
  type: OfferPdfTypeEnum;
};


export type MutationRegisterArgs = {
  user: RegisterUserInput;
};


export type MutationRegisterLeadArgs = {
  address: AddressInput;
  customer: CustomerInput;
};


export type MutationRemoveConstantArgs = {
  code: Scalars['String'];
};


export type MutationSetOfferExpensesArgs = {
  expenses: Array<OfferExpenseInput>;
  offerID: Scalars['Int'];
};


export type MutationSetResidenceRoofTypeArgs = {
  residenceId: Scalars['Int'];
  roofType: RoofType;
};


export type MutationSyncContactInformationWithCrmArgs = {
  residenceId: Scalars['Int'];
};


export type MutationSyncOfferExpensesArgs = {
  offerID: Scalars['Int'];
};


export type MutationSyncOfferInformationWithCrmArgs = {
  offerId: Scalars['Int'];
};


export type MutationUnarchiveOfferArgs = {
  id: Scalars['Int'];
};


export type MutationUnregisterArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateAssortedProductArgs = {
  id: Scalars['Int'];
  unit: AssortedProductInput;
};


export type MutationUpdateAssortedProductImageArgs = {
  id: Scalars['Int'];
  image: Scalars['Upload'];
};


export type MutationUpdateBatteryArgs = {
  id: Scalars['Int'];
  unit: BatteryInput;
};


export type MutationUpdateBatteryImageArgs = {
  id: Scalars['Int'];
  image: Scalars['Upload'];
};


export type MutationUpdateBatteryRangeArgs = {
  batteryRangeInput: BatteryRangeInput;
  id: Scalars['Int'];
};


export type MutationUpdateConstantArgs = {
  constant: ConstantInput;
};


export type MutationUpdateContactScoringFieldsArgs = {
  email: Scalars['String'];
  scoringFields: ScoringFields;
};


export type MutationUpdateHeatPumpIndoorImageArgs = {
  id: Scalars['Int'];
  image: Scalars['Upload'];
};


export type MutationUpdateHeatPumpIndoorUnitArgs = {
  id: Scalars['Int'];
  unit: HeatPumpIndoorUnitInput;
};


export type MutationUpdateHeatPumpOutdoorImageArgs = {
  id: Scalars['Int'];
  image: Scalars['Upload'];
};


export type MutationUpdateHeatPumpOutdoorUnitArgs = {
  id: Scalars['Int'];
  unit: HeatPumpOutdoorUnitInput;
};


export type MutationUpdateHeatPumpPackageArgs = {
  heatPumpPackageInput: HeatPumpPackageInput;
  id: Scalars['Int'];
};


export type MutationUpdateInverterArgs = {
  id: Scalars['Int'];
  unit: InverterInput;
};


export type MutationUpdateInverterImageArgs = {
  id: Scalars['Int'];
  image: Scalars['Upload'];
};


export type MutationUpdateOfferNotesArgs = {
  notes: Scalars['String'];
  offerID: Scalars['Int'];
};


export type MutationUpdateOfferProductPriceArgs = {
  offerID: Scalars['Int'];
  price: Scalars['Float'];
  type: OfferProductType;
  unitID: Scalars['Int'];
};


export type MutationUpdatePasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUpdateProductDescriptionArgs = {
  description: ProductDescriptionInput;
  id: Scalars['Int'];
};


export type MutationUpdateSolarPanelArgs = {
  id: Scalars['Int'];
  unit: SolarPanelInput;
};


export type MutationUpdateSolarPanelImageArgs = {
  id: Scalars['Int'];
  image: Scalars['Upload'];
};


export type MutationUpdateSolarProductPackageArgs = {
  id: Scalars['Int'];
  solarPackageInput: SolarProductPackageInput;
};


export type MutationUpdateUserArgs = {
  user: UpdateUserInput;
};


export type MutationUploadAssortedProductDatasheetArgs = {
  datasheet: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationUploadBatteryDatasheetArgs = {
  datasheet: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationUploadHeatPumpIndoorUnitDatasheetArgs = {
  datasheet: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationUploadHeatPumpOutdoorUnitDatasheetArgs = {
  datasheet: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationUploadInverterDatasheetArgs = {
  datasheet: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationUploadPublicFileArgs = {
  file: Scalars['Upload'];
};


export type MutationUploadResidenceImagesArgs = {
  category?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  images: Array<Scalars['Upload']>;
};


export type MutationUploadSiteVisitFileArgs = {
  code?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  offerID: Scalars['Int'];
};


export type MutationUploadSolarPanelDatasheetArgs = {
  datasheet: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationUpsertCustomerArgs = {
  customer: CustomerInput;
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationUpsertExpenseTemplateArgs = {
  template: OfferExpenseTemplateInput;
};


export type MutationUpsertReservationArgs = {
  offerID: Scalars['Int'];
  reservation: Scalars['String'];
};


export type MutationUpsertResidenceArgs = {
  customerID?: InputMaybe<Scalars['Int']>;
  customerInput?: InputMaybe<CustomerInput>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  residence: ResidenceInput;
};


export type MutationUpsertSiteVisitAnswerListArgs = {
  answerList: Array<SiteVisitAnswerInput>;
  code?: InputMaybe<Scalars['String']>;
};

export type NewOfferExpenses = {
  heatPump: Array<OfferExpenseTemplate>;
  solar: Array<OfferExpenseTemplate>;
};

export type Offer = {
  address?: Maybe<Address>;
  assortedProducts?: Maybe<Array<AssortedProduct>>;
  battery?: Maybe<Battery>;
  batteryProduct?: Maybe<Product>;
  chosenHeating?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  customer?: Maybe<Customer>;
  deletedAt?: Maybe<Scalars['Float']>;
  expenses?: Maybe<Array<OfferExpense>>;
  finalPreview: Scalars['String'];
  heatPumpIndoorProduct?: Maybe<Product>;
  heatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  heatPumpOutdoorProduct?: Maybe<Product>;
  heatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  id: Scalars['Int'];
  installationAccessCode: Scalars['String'];
  inverter?: Maybe<Inverter>;
  inverterProduct?: Maybe<Product>;
  notes?: Maybe<Scalars['String']>;
  preferred?: Maybe<Scalars['Boolean']>;
  preliminaryPreview: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  reservations?: Maybe<Scalars['String']>;
  residence?: Maybe<Residence>;
  residenceID: Scalars['Int'];
  sentOffers?: Maybe<Array<OfferDispatch>>;
  siteVisitAccessCode: Scalars['String'];
  solarPanel?: Maybe<SolarPanel>;
  solarPanelProduct?: Maybe<Product>;
  tag: Scalars['String'];
  updatedAt?: Maybe<Scalars['Float']>;
};

export type OfferActor =
  | 'advisor'
  | 'customer';

export type OfferDispatch = {
  id: Scalars['Int'];
  sentAt?: Maybe<Scalars['Float']>;
  type?: Maybe<OfferPdfTypeEnum>;
};

export type OfferExpense = {
  buyPrice: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  includedByDefault?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  offerID: Scalars['Int'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  templateID?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<OfferExpenseType>;
};

export type OfferExpenseInput = {
  buyPrice: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity?: InputMaybe<Scalars['Int']>;
  templateID?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OfferExpenseType>;
};

export type OfferExpenseTemplate = {
  automations?: Maybe<Array<ExpenseAutomation>>;
  buyPrice: Scalars['Float'];
  createdAt: Scalars['Float'];
  denominator?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  includedByDefault?: Maybe<Scalars['Boolean']>;
  locked?: Maybe<Scalars['Boolean']>;
  minimumProducts?: Maybe<Scalars['Int']>;
  offerType?: Maybe<OfferType>;
  price: Scalars['Float'];
  title: Scalars['String'];
  type: OfferExpenseTemplateType;
  updatedAt?: Maybe<Scalars['Float']>;
};

export type OfferExpenseTemplateInput = {
  automations?: InputMaybe<Array<ExpenseAutomationInput>>;
  buyPrice: Scalars['Float'];
  denominator?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  includedByDefault?: InputMaybe<Scalars['Boolean']>;
  offerType: OfferType;
  price: Scalars['Float'];
  title: Scalars['String'];
  type: OfferExpenseTemplateType;
};

export type OfferExpenseTemplateType =
  | 'batteryInstallation'
  | 'indoorUnitInstallation'
  | 'inverterInstallation'
  | 'nonPhysical'
  | 'outdoorUnitInstallation'
  | 'physical'
  | 'solarPanelInstallation';

export type OfferExpenseType =
  | 'installation'
  | 'nonPhysical'
  | 'physical';

export type OfferInput = {
  assortedProducts?: InputMaybe<Array<ProductInput>>;
  batteryProduct?: InputMaybe<ProductInput>;
  chosenHeating?: InputMaybe<Scalars['Float']>;
  discount?: InputMaybe<Scalars['Int']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Int']>;
  expenses?: InputMaybe<Array<OfferExpenseInput>>;
  heatPumpIndoorProduct?: InputMaybe<ProductInput>;
  heatPumpOutdoorProduct?: InputMaybe<ProductInput>;
  inverterProduct?: InputMaybe<ProductInput>;
  notes?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<Scalars['String']>;
  solarPanelProduct?: InputMaybe<ProductInput>;
  withoutInstallation?: InputMaybe<Scalars['Boolean']>;
};

export type OfferPdfTypeEnum =
  | 'final'
  | 'preliminary';

export type OfferProductType =
  | 'assorted'
  | 'battery'
  | 'heatPumpIndoorUnit'
  | 'heatPumpOutdoorUnit'
  | 'inverter'
  | 'solarPanel';

export type OfferProducts = {
  battery?: Maybe<Battery>;
  expenses?: Maybe<Array<OfferExpense>>;
  heatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  heatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  inverter?: Maybe<Inverter>;
  price?: Maybe<Scalars['Float']>;
  solarPackageDiscount?: Maybe<Scalars['Int']>;
  solarPackageId?: Maybe<Scalars['Int']>;
  solarPanel?: Maybe<SolarPanel>;
};

export type OfferSavings = {
  after: ProductUsage;
  before: ProductUsage;
  saved: OfferTotalSaved;
};

export type OfferSavingsWithProducts = {
  disclaimer: Scalars['String'];
  investment: Scalars['Float'];
  paybackMonths: Scalars['Float'];
  products: OfferProducts;
  residence?: Maybe<SimpleResidenceResult>;
  savings: OfferSavings;
  types: Array<OfferType>;
};

export type OfferTotalSaved = {
  emission: Scalars['Float'];
  price: Scalars['Float'];
  priceByYear: Array<Scalars['Float']>;
};

export type OfferType =
  | 'assorted'
  | 'heatPump'
  | 'solar';

export type OffersWithCount = {
  count: Scalars['Int'];
  offers: Array<Offer>;
};

export type PanelCategory =
  | 'builtIn'
  | 'freeStanding';

export type PanelType =
  | 'monoCrystal'
  | 'polyCrystal';

export type PartialHouseInput = {
  annualElectricityPrice?: InputMaybe<Scalars['Float']>;
  annualHeatingPrice?: InputMaybe<Scalars['Float']>;
  area?: InputMaybe<Scalars['Int']>;
  fuelType?: InputMaybe<FuelType>;
};

export type PartialResidenceInput = {
  addressID?: InputMaybe<Scalars['Float']>;
  area?: InputMaybe<Scalars['Float']>;
  areaHeated?: InputMaybe<Scalars['Float']>;
  areaNotHeated?: InputMaybe<Scalars['Float']>;
  areaPartiallyHeated?: InputMaybe<Scalars['Float']>;
  customerID?: InputMaybe<Scalars['Float']>;
  electricCar?: InputMaybe<ElectricCarInput>;
  energyExpenditure?: InputMaybe<Scalars['Float']>;
  energyLabel?: InputMaybe<EnergyLabelEnum>;
  heatDistribution?: InputMaybe<HeatDistributionTypeEnum>;
  primaryHeating?: InputMaybe<ResidenceHeatingInput>;
  radiatorFloorPercentage?: InputMaybe<Scalars['Float']>;
  roofs?: InputMaybe<Array<RoofInput>>;
  secondaryHeating?: InputMaybe<ResidenceHeatingInput>;
  type?: InputMaybe<ResidenceType>;
};

export type PartnerCustomerInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  leadOrigin: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type PartnerResidenceInput = {
  annualElectricityPrice: Scalars['Float'];
  annualHeatingPrice: Scalars['Float'];
  fuelType: FuelType;
};

export type Product = {
  id: Scalars['Int'];
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type ProductDescription = {
  content: Scalars['String'];
  id: Scalars['Int'];
  title: Scalars['String'];
  type: OfferProductType;
};

export type ProductDescriptionInput = {
  content: Scalars['String'];
  title: Scalars['String'];
  type: OfferProductType;
};

export type ProductInput = {
  buyPrice?: InputMaybe<Scalars['Float']>;
  id: Scalars['Int'];
  price?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ProductUsage = {
  bought: Scalars['Float'];
  boughtPrice?: Maybe<Scalars['Float']>;
  consumptionPerMonth?: Maybe<Array<Scalars['Float']>>;
  domesticDiscount: Scalars['Float'];
  domesticPrice: Scalars['Float'];
  electricityDiscount?: Maybe<Scalars['Float']>;
  fuelPrice?: Maybe<Scalars['Float']>;
  netEarning?: Maybe<Scalars['Float']>;
  netSpentElectricity?: Maybe<Scalars['Float']>;
  produced: Scalars['Float'];
  productionPerMonth?: Maybe<Array<Scalars['Float']>>;
  sold: Scalars['Float'];
  soldPrice?: Maybe<Scalars['Float']>;
  totalEmission?: Maybe<Scalars['Float']>;
  totalPrice: Scalars['Float'];
  used: Scalars['Float'];
  usedPercentage?: Maybe<Scalars['Float']>;
};

export type Query = {
  addressSavings: AllOfferSavings;
  allOfferTypeSavings: Array<OfferSavingsWithProducts>;
  assortedProduct?: Maybe<AssortedProduct>;
  assortedProductBrands: Array<Scalars['String']>;
  assortedProducts: Array<AssortedProduct>;
  batteries: Array<Battery>;
  battery?: Maybe<Battery>;
  batteryBrands: Array<Scalars['String']>;
  batteryRanges: Array<BatteryProductRange>;
  bbrLookupByAddress?: Maybe<BbrResidence>;
  bbrLookupByDawaId?: Maybe<BbrResidence>;
  bodilAdvisors: Array<User>;
  calculateAddressSavings: AllOfferSavings;
  calculateAddressSavingsLokalBolig: AllOfferSavings;
  calculateAddressSavingsPartialResidenceEDC: AllOfferSavings;
  calculateEnergyLabels: EnergyLabels;
  calculateOfferSavings: OfferSavings;
  calculateOfferTypeSavings: OfferSavingsWithProducts;
  constants: Array<Constant>;
  constantsWithPartialCode: Array<Constant>;
  crmCustomerFieldValues?: Maybe<CrmCustomerFields>;
  customer?: Maybe<Customer>;
  dashboardOffers: OffersWithCount;
  energyLabel?: Maybe<EnergyLabelEnum>;
  energyOptions: Array<Constant>;
  expenseTemplates: Array<OfferExpenseTemplate>;
  heatPumpBrands: Array<Scalars['String']>;
  heatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  heatPumpIndoorUnits: Array<HeatPumpIndoorUnit>;
  heatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  heatPumpOutdoorUnits: Array<HeatPumpOutdoorUnit>;
  heatPumpPackages: Array<HeatPumpProductPackage>;
  inverter?: Maybe<Inverter>;
  inverterBrands: Array<Scalars['String']>;
  inverters: Array<Inverter>;
  me: User;
  newOfferExpenses: NewOfferExpenses;
  offer?: Maybe<Offer>;
  offerByCode?: Maybe<Offer>;
  offerByTag?: Maybe<Offer>;
  offerSavings: OfferSavings;
  offerTypeSavings: OfferSavingsWithProducts;
  offers?: Maybe<Array<Offer>>;
  productDescriptions: Array<ProductDescription>;
  recommendedSolarPackage: SolarProductPackage;
  residence?: Maybe<Residence>;
  residences?: Maybe<Array<Residence>>;
  residencesBySearch: Array<Residence>;
  searchCRMCustomers?: Maybe<Array<CrmCustomer>>;
  searchCustomers?: Maybe<Array<Customer>>;
  searchCustomersByEmail?: Maybe<Array<Customer>>;
  siteVisitAnswerList: Array<SiteVisitAnswer>;
  siteVisitFiles: Array<SiteVisitFile>;
  solarPackageSavings: Array<SolarPackageSavings>;
  solarPanel?: Maybe<SolarPanel>;
  solarPanelBrands: Array<Scalars['String']>;
  solarPanels: Array<SolarPanel>;
  solarProductPackages: Array<SolarProductPackage>;
  user?: Maybe<User>;
};


export type QueryAddressSavingsArgs = {
  dawaId: Scalars['String'];
  isAdvisor?: InputMaybe<Scalars['Boolean']>;
  residence?: InputMaybe<HouseInputWithUsage>;
};


export type QueryAllOfferTypeSavingsArgs = {
  address: AddressInput;
  chosenHeating?: InputMaybe<Scalars['Float']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']>>;
  customerID?: InputMaybe<Scalars['Float']>;
  isAdvisor?: InputMaybe<Scalars['Boolean']>;
  residence?: InputMaybe<PartialResidenceInput>;
  types: Array<OfferType>;
};


export type QueryAssortedProductArgs = {
  id: Scalars['Int'];
};


export type QueryAssortedProductsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryBatteriesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBatteryArgs = {
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBatteryRangesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryBbrLookupByAddressArgs = {
  address: AddressInput;
};


export type QueryBbrLookupByDawaIdArgs = {
  dawaId: Scalars['String'];
};


export type QueryCalculateAddressSavingsArgs = {
  dawaId: Scalars['String'];
  residence?: InputMaybe<HouseInput>;
};


export type QueryCalculateAddressSavingsLokalBoligArgs = {
  dawaId: Scalars['String'];
  residence?: InputMaybe<HouseInput>;
};


export type QueryCalculateAddressSavingsPartialResidenceEdcArgs = {
  dawaId: Scalars['String'];
  residence?: InputMaybe<PartialHouseInput>;
};


export type QueryCalculateEnergyLabelsArgs = {
  address: AddressInput;
  residence?: InputMaybe<PartialResidenceInput>;
};


export type QueryCalculateOfferSavingsArgs = {
  address: AddressInput;
  chosenHeating?: InputMaybe<Scalars['Float']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']>>;
  customerID?: InputMaybe<Scalars['Float']>;
  offer: OfferInput;
  residence?: InputMaybe<PartialResidenceInput>;
};


export type QueryCalculateOfferTypeSavingsArgs = {
  address: AddressInput;
  chosenHeating?: InputMaybe<Scalars['Float']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']>>;
  customerID?: InputMaybe<Scalars['Float']>;
  residence?: InputMaybe<PartialResidenceInput>;
  types: Array<OfferType>;
};


export type QueryConstantsArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type QueryConstantsWithPartialCodeArgs = {
  partialCode: Scalars['String'];
};


export type QueryCrmCustomerFieldValuesArgs = {
  id: Scalars['String'];
};


export type QueryCustomerArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryDashboardOffersArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offerType?: InputMaybe<OfferType>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<SortOrder>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryEnergyLabelArgs = {
  addressId: Scalars['String'];
};


export type QueryEnergyOptionsArgs = {
  residenceId?: InputMaybe<Scalars['Int']>;
};


export type QueryExpenseTemplatesArgs = {
  type: OfferType;
};


export type QueryHeatPumpIndoorUnitArgs = {
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHeatPumpIndoorUnitsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHeatPumpOutdoorUnitArgs = {
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHeatPumpOutdoorUnitsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHeatPumpPackagesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryInverterArgs = {
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInvertersArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOfferArgs = {
  id: Scalars['Int'];
};


export type QueryOfferByCodeArgs = {
  code: Scalars['String'];
  purpose: TokenPurpose;
};


export type QueryOfferByTagArgs = {
  offerTag: Scalars['String'];
};


export type QueryOfferSavingsArgs = {
  address?: InputMaybe<AddressInput>;
  chosenHeating?: InputMaybe<Scalars['Float']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']>>;
  customerID?: InputMaybe<Scalars['Float']>;
  offer: OfferInput;
  residence: ResidenceInput;
};


export type QueryOfferTypeSavingsArgs = {
  address: AddressInput;
  chosenHeating?: InputMaybe<Scalars['Float']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']>>;
  customerID?: InputMaybe<Scalars['Float']>;
  isAdvisor?: InputMaybe<Scalars['Boolean']>;
  residence?: InputMaybe<PartialResidenceInput>;
  types: Array<OfferType>;
};


export type QueryOffersArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  customerID?: InputMaybe<Scalars['Int']>;
  residenceID?: InputMaybe<Scalars['Int']>;
};


export type QueryProductDescriptionsArgs = {
  type: OfferProductType;
};


export type QueryRecommendedSolarPackageArgs = {
  residence: ResidenceInput;
};


export type QueryResidenceArgs = {
  address?: InputMaybe<AddressInput>;
  customerID?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryResidencesArgs = {
  address?: InputMaybe<AddressInput>;
  customerID?: InputMaybe<Scalars['Int']>;
};


export type QueryResidencesBySearchArgs = {
  actor?: InputMaybe<OfferActor>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchCrmCustomersArgs = {
  email: Scalars['String'];
};


export type QuerySearchCustomersArgs = {
  search: Scalars['String'];
};


export type QuerySearchCustomersByEmailArgs = {
  email: Scalars['String'];
};


export type QuerySiteVisitAnswerListArgs = {
  residenceID: Scalars['Int'];
};


export type QuerySiteVisitFilesArgs = {
  code?: InputMaybe<Scalars['String']>;
  offerID: Scalars['Int'];
};


export type QuerySolarPackageSavingsArgs = {
  residence: ResidenceInput;
};


export type QuerySolarPanelArgs = {
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySolarPanelsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySolarProductPackagesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isAdvisor?: InputMaybe<Scalars['Boolean']>;
  onlyDefaultBattery?: InputMaybe<Scalars['Boolean']>;
};


export type QueryUserArgs = {
  id: Scalars['Int'];
};

/** register user */
export type RegisterUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};

export type RenovationDegreeEnum =
  | 'asBuilt'
  | 'maximum'
  | 'medium';

export type Residence = {
  address?: Maybe<Address>;
  addressID: Scalars['Int'];
  area: Scalars['Float'];
  areaHeated: Scalars['Float'];
  areaNotHeated?: Maybe<Scalars['Int']>;
  areaPartiallyHeated?: Maybe<Scalars['Float']>;
  builtYear?: Maybe<Scalars['Float']>;
  consumption?: Maybe<Consumption>;
  consumptionProfile?: Maybe<ConsumptionProfile>;
  createdAt: Scalars['Float'];
  customer?: Maybe<Customer>;
  customerID: Scalars['Int'];
  electricCar?: Maybe<ElectricCar>;
  electricityPrice?: Maybe<Scalars['Float']>;
  energyExpenditure: Scalars['Float'];
  energyLabel?: Maybe<EnergyLabelEnum>;
  floors: Scalars['Float'];
  hasExistingSolarPanels?: Maybe<Scalars['Boolean']>;
  heatDistribution: HeatDistributionTypeEnum;
  heatingCircuits?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  images: Array<Image>;
  monthlyConsumption?: Maybe<MonthlyConsumption>;
  monthlyConsumptionProfile?: Maybe<MonthlyConsumptionProfile>;
  noiseWeight: WaterConsumptionDegreeEnum;
  offerProducts?: Maybe<Array<OfferType>>;
  primaryHeating?: Maybe<ResidenceHeating>;
  radiatorFloorPercentage?: Maybe<Scalars['Float']>;
  renovatedDegree?: Maybe<RenovationDegreeEnum>;
  renovatedYear?: Maybe<Scalars['Float']>;
  residents?: Maybe<Scalars['Float']>;
  roofType?: Maybe<RoofType>;
  roofs?: Maybe<Array<Roof>>;
  secondaryHeating?: Maybe<ResidenceHeating>;
  type: ResidenceType;
  updatedAt?: Maybe<Scalars['Float']>;
  waterConsumption: WaterConsumptionDegreeEnum;
};

export type ResidenceHeating = {
  annualUsage: Scalars['Float'];
  efficiency?: Maybe<Scalars['Float']>;
  fuelSubtype?: Maybe<Scalars['String']>;
  fuelType: Scalars['String'];
  heatSource?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  price?: Maybe<Scalars['Float']>;
  priority: HeatingPriority;
  volumeUnit?: Maybe<Scalars['String']>;
};

export type ResidenceHeatingInput = {
  annualUsage: Scalars['Float'];
  efficiency?: InputMaybe<Scalars['Float']>;
  fuelSubtype?: InputMaybe<Scalars['String']>;
  fuelType: Scalars['String'];
  heatSource?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  priority?: InputMaybe<HeatingPriority>;
  volumeUnit?: InputMaybe<Scalars['String']>;
};

export type ResidenceInput = {
  address?: InputMaybe<AddressInput>;
  addressID?: InputMaybe<Scalars['Int']>;
  area: Scalars['Float'];
  areaHeated: Scalars['Float'];
  areaNotHeated?: InputMaybe<Scalars['Int']>;
  areaPartiallyHeated?: InputMaybe<Scalars['Float']>;
  builtYear?: InputMaybe<Scalars['Float']>;
  consumptionProfile?: InputMaybe<ConsumptionProfile>;
  customerID?: InputMaybe<Scalars['Int']>;
  electricCar?: InputMaybe<ElectricCarInput>;
  electricityPrice?: InputMaybe<Scalars['Float']>;
  energyExpenditure: Scalars['Float'];
  energyLabel?: InputMaybe<EnergyLabelEnum>;
  floors: Scalars['Int'];
  hasExistingSolarPanels?: InputMaybe<Scalars['Boolean']>;
  heatDistribution: HeatDistributionTypeEnum;
  heatingCircuits?: InputMaybe<Scalars['Int']>;
  monthlyConsumptionProfile?: InputMaybe<MonthlyConsumptionProfile>;
  noiseWeight?: InputMaybe<WaterConsumptionDegreeEnum>;
  primaryHeating: ResidenceHeatingInput;
  radiatorFloorPercentage?: InputMaybe<Scalars['Float']>;
  renovatedDegree?: InputMaybe<RenovationDegreeEnum>;
  renovatedYear?: InputMaybe<Scalars['Float']>;
  residents?: InputMaybe<Scalars['Float']>;
  roofType?: InputMaybe<RoofType>;
  roofs?: InputMaybe<Array<RoofInput>>;
  secondaryHeating?: InputMaybe<ResidenceHeatingInput>;
  type: ResidenceType;
  waterConsumption: WaterConsumptionDegreeEnum;
};

export type ResidenceOwnership =
  | 'lookingToBuy'
  | 'owner'
  | 'renting';

export type ResidenceType =
  | 'apartment'
  | 'summerhouse'
  | 'townhouse'
  | 'villa';

export type Roof = {
  height?: Maybe<Scalars['Float']>;
  isGuessed?: Maybe<Scalars['Boolean']>;
  maxPanelCoverage?: Maybe<Scalars['Float']>;
  orientation: Scalars['Float'];
  planeDepth: Scalars['Float'];
  planeWidth: Scalars['Float'];
  shadows?: Maybe<RoofShadows>;
};

export type RoofInput = {
  height?: InputMaybe<Scalars['Int']>;
  isGuessed?: InputMaybe<Scalars['Boolean']>;
  maxPanelCoverage?: InputMaybe<Scalars['Float']>;
  orientation: Scalars['Int'];
  planeDepth: Scalars['Int'];
  planeWidth: Scalars['Int'];
  shadows?: InputMaybe<RoofShadows>;
};

export type RoofShadows =
  | 'many'
  | 'none'
  | 'some';

export type RoofType =
  | 'clayTile'
  | 'concreteTile'
  | 'felt'
  | 'fiberCement'
  | 'flat'
  | 'metal'
  | 'other'
  | 'unknown';

export type ScoringFields = {
  heatingSource?: InputMaybe<HeatingSource>;
  interestedInAdvice?: InputMaybe<InterestedInAdvice>;
  investmentTime?: InputMaybe<InvestmentTime>;
  referencedBy?: InputMaybe<SourceOfReference>;
  residenceOwnership?: InputMaybe<ResidenceOwnership>;
  yearlyElectricityCost?: InputMaybe<YearlyElectricityCost>;
  yearlyHeatingCost?: InputMaybe<YearlyHeatingCost>;
};

export type SimpleResidenceResult = {
  annualElectricityPrice: Scalars['Float'];
  annualHeatingPrice: Scalars['Float'];
  existingSolarArrayEffect?: Maybe<Scalars['Float']>;
  fuelType: FuelType;
};

export type SiteVisitAnswer = {
  answer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  question?: Maybe<SiteVisitQuestion>;
  residenceId: Scalars['Int'];
};

export type SiteVisitAnswerInput = {
  answer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  question: SiteVisitQuestion;
  residenceId: Scalars['Int'];
};

export type SiteVisitFile = {
  id: Scalars['Float'];
  name: Scalars['String'];
  offerID: Scalars['Float'];
  url: Scalars['String'];
};

export type SiteVisitQuestion =
  | 'atticOrRaisedCelling'
  | 'bufferRequired'
  | 'bufferRequiredSolar'
  | 'bypassValves'
  | 'canFurnaceBeDismantled'
  | 'changeCirculationPump'
  | 'condensationPump'
  | 'correctColdRooms'
  | 'correctConsumption'
  | 'correctConsumptionSecondary'
  | 'correctHeatedArea'
  | 'digDownPipes'
  | 'distanceInOut'
  | 'distanceToInstallation'
  | 'distanceToSolar'
  | 'easyAvailableForScaffolding'
  | 'electricRelayAutoSafetyAndExtra'
  | 'electricRelayWork'
  | 'electricityNotes'
  | 'electricitySolarNotes'
  | 'floorHeatingExtraShunts'
  | 'floorPlanNotes'
  | 'hasUnderRoof'
  | 'heatPumpEntryPossible'
  | 'heatSourceNotes'
  | 'indoorAlternativeNotes'
  | 'indoorPlacementNotes'
  | 'indoorUnitOnFloorPlan'
  | 'installationOnFloorPlan'
  | 'inverterAndBatteryOnFloorPlan'
  | 'inverterAndBatteryPlacementNotes'
  | 'noiseLimitObserved'
  | 'otherNotes'
  | 'outdoorPlacementNotes'
  | 'outdoorUnitOnFloorPlan'
  | 'pipingMaterial'
  | 'pipingNotes'
  | 'pipingOnFloorPlan'
  | 'pipingPlacement'
  | 'providerForFoundation'
  | 'providerForFoundationSolar'
  | 'radiatorPipingSize'
  | 'radiatorsNotes'
  | 'replaceFurnaceWithRadiator'
  | 'replaceRadiators'
  | 'roofConstructionNotes'
  | 'roofType'
  | 'roomForMaterials'
  | 'roomForWaterTank'
  | 'solarCableOnFloorPlan'
  | 'solarEntryPossible'
  | 'solarOnFloorPlan'
  | 'solarPlacementNotes'
  | 'systemStringNumber'
  | 'twoPipingSystems'
  | 'wiringInCeiling'
  | 'wiringInCeilingForSolar';

export type SolarOfferInput = {
  batteryProduct?: InputMaybe<ProductInput>;
  discount?: InputMaybe<Scalars['Int']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Int']>;
  expenses?: InputMaybe<Array<OfferExpenseInput>>;
  inverterProduct?: InputMaybe<ProductInput>;
  notes?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<Scalars['String']>;
  solarPanelProduct?: InputMaybe<ProductInput>;
  withoutInstallation?: InputMaybe<Scalars['Boolean']>;
};

export type SolarPackageSavings = {
  packageID: Scalars['Int'];
  quantity: Scalars['Float'];
  savings: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
  totalPrice: Scalars['Float'];
  totalSaved: Scalars['Float'];
  usedPercentage: Scalars['Float'];
};

export type SolarPanel = {
  annualProduction: Scalars['Float'];
  brand: Scalars['String'];
  buyPrice?: Maybe<Scalars['Float']>;
  capacity: Scalars['Float'];
  category: PanelCategory;
  compatibleInverters: Array<Scalars['Int']>;
  customerEnabled?: Maybe<Scalars['Boolean']>;
  datasheetUrl?: Maybe<Scalars['String']>;
  degradationPerYear: Scalars['Float'];
  deletedAt?: Maybe<Scalars['Float']>;
  descriptionId?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  imageUrl?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  offerID?: Maybe<Scalars['Float']>;
  performanceWarrantyYears: Scalars['Int'];
  preferred?: Maybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  productWarrantyYears: Scalars['Int'];
  quantity?: Maybe<Scalars['Int']>;
  size: BoxSize;
  type: PanelType;
  webshopEnabled?: Maybe<Scalars['Boolean']>;
  weight: Scalars['Float'];
};

export type SolarPanelInput = {
  annualProduction: Scalars['Float'];
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String'];
  buyPrice?: InputMaybe<Scalars['Float']>;
  capacity: Scalars['Float'];
  category: PanelCategory;
  compatibleInverters: Array<Scalars['Int']>;
  customerEnabled?: InputMaybe<Scalars['Boolean']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']>;
  degradationPerYear: Scalars['Float'];
  deletedAt?: InputMaybe<Scalars['Float']>;
  descriptionId?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  model: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  performanceWarrantyYears: Scalars['Int'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  productWarrantyYears: Scalars['Int'];
  type: PanelType;
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
  weight: Scalars['Float'];
};

export type SolarProductPackage = {
  batteries?: Maybe<Array<Battery>>;
  batteryRangeID?: Maybe<Scalars['Int']>;
  calculatorEnabled?: Maybe<Scalars['Boolean']>;
  defaultBatteryID?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['Float']>;
  discountWithoutInstallation?: Maybe<Scalars['Float']>;
  inverter: Inverter;
  maximumEnergyExpenditure?: Maybe<Scalars['Float']>;
  packageID: Scalars['Int'];
  solarPanel: SolarPanel;
  title?: Maybe<Scalars['String']>;
  webshopEnabled?: Maybe<Scalars['Boolean']>;
};

export type SolarProductPackageInput = {
  batteryRangeID?: InputMaybe<Scalars['Int']>;
  calculatorEnabled?: InputMaybe<Scalars['Boolean']>;
  defaultBatteryID?: InputMaybe<Scalars['Int']>;
  discount?: InputMaybe<Scalars['Float']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Float']>;
  inverterID: Scalars['Int'];
  solarPanelID: Scalars['Int'];
  solarPanelQuantity: Scalars['Int'];
  title: Scalars['String'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type SortOrder =
  | 'ascending'
  | 'descending';

export type SourceOfReference =
  | 'google'
  | 'meta'
  | 'other'
  | 'partner'
  | 'trustPilot'
  | 'wordOfMouth';

export type TokenPurpose =
  | 'forgotPassword'
  | 'installationAccess'
  | 'refreshToken'
  | 'siteVisitAccess'
  | 'verifyEmail';

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type User = {
  authProviders?: Maybe<Array<AuthProvider>>;
  createdAt: Scalars['Float'];
  email: Scalars['String'];
  emailVerified?: Maybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  isAdmin: Scalars['Boolean'];
  isMe: Scalars['Boolean'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  profileImageID?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

export type UtmFields = {
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
};

export type WaterConsumptionDegreeEnum =
  | 'large'
  | 'medium'
  | 'small';

export type YearlyElectricityCost =
  | 'between4000and14000'
  | 'lessThan4000'
  | 'moreThan14000'
  | 'unknown';

export type YearlyHeatingCost =
  | 'between15000and25000'
  | 'lessThan15000'
  | 'moreThan25000'
  | 'unknown';

export type AssortedProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type AssortedProductsQuery = { assortedProducts: Array<{ id: number, brand: string, model: string, descriptionId?: number | null, price: number, buyPrice?: number | null, datasheetUrl?: string | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> };

export type AssortedProductBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type AssortedProductBrandsQuery = { assortedProductBrands: Array<string> };

export type AssortedProductQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AssortedProductQuery = { assortedProduct?: { id: number, brand: string, model: string, descriptionId?: number | null, price: number, buyPrice?: number | null, datasheetUrl?: string | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null };

export type InsertAssortedProductMutationVariables = Exact<{
  unit: AssortedProductInput;
}>;


export type InsertAssortedProductMutation = { insertAssortedProduct?: { id: number } | null };

export type UpdateAssortedProductMutationVariables = Exact<{
  unit: AssortedProductInput;
  id: Scalars['Int'];
}>;


export type UpdateAssortedProductMutation = { updateAssortedProduct?: { id: number } | null };

export type UpdateAssortedProductImageMutationVariables = Exact<{
  image: Scalars['Upload'];
  id: Scalars['Int'];
}>;


export type UpdateAssortedProductImageMutation = { updateAssortedProductImage: string };

export type RefreshLoginMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RefreshLoginMutation = { refreshLogin: { accessToken: string, refreshToken: string } };

export type BatteriesQueryVariables = Exact<{
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type BatteriesQuery = { batteries: Array<{ id: number, brand: string, model: string, weight: number, efficiency: number, capacity: number, warrantyYears?: number | null, warrantyCycles?: number | null, datasheetUrl?: string | null, descriptionId?: number | null, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> };

export type CompatibleBatteriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompatibleBatteriesQuery = { batteries: Array<{ id: number, brand: string, model: string }> };

export type BatteryQueryVariables = Exact<{
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type BatteryQuery = { battery?: { id: number, brand: string, model: string, weight: number, efficiency: number, capacity: number, warrantyYears?: number | null, warrantyCycles?: number | null, datasheetUrl?: string | null, descriptionId?: number | null, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null };

export type BatteryBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type BatteryBrandsQuery = { batteryBrands: Array<string> };

export type InsertBatteryMutationVariables = Exact<{
  unit: BatteryInput;
}>;


export type InsertBatteryMutation = { insertBattery?: { id: number } | null };

export type UpdateBatteryMutationVariables = Exact<{
  unit: BatteryInput;
  id: Scalars['Int'];
}>;


export type UpdateBatteryMutation = { updateBattery?: { id: number } | null };

export type UpdateBatteryImageMutationVariables = Exact<{
  image: Scalars['Upload'];
  id: Scalars['Int'];
}>;


export type UpdateBatteryImageMutation = { updateBatteryImage: string };

export type BatteryRangesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type BatteryRangesQuery = { batteryRanges: Array<{ id: number, title: string, batteries: Array<{ id: number, brand: string, model: string, weight: number, efficiency: number, capacity: number, warrantyYears?: number | null, warrantyCycles?: number | null, datasheetUrl?: string | null, descriptionId?: number | null, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> }> };

export type CreateBatteryRangeMutationVariables = Exact<{
  batteryRangeInput: BatteryRangeInput;
}>;


export type CreateBatteryRangeMutation = { createBatteryRange: { id: number } };

export type UpdateBatteryRangeMutationVariables = Exact<{
  id: Scalars['Int'];
  batteryRangeInput: BatteryRangeInput;
}>;


export type UpdateBatteryRangeMutation = { updateBatteryRange: { id: number } };

export type DeleteBatteryRangeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteBatteryRangeMutation = { deleteBatteryRange: boolean };

export type ConstantFragment = { id: number, code: string, valueNumber: number, numerator: string, denominator?: string | null };

export type UpdateConstantMutationVariables = Exact<{
  constant: ConstantInput;
}>;


export type UpdateConstantMutation = { updateConstant: { code: string } };

export type ConstantsQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type ConstantsQuery = { constants: Array<{ id: number, code: string, valueNumber: number, numerator: string, denominator?: string | null }> };

export type ExpenseTemplatesQueryVariables = Exact<{
  type: OfferType;
}>;


export type ExpenseTemplatesQuery = { expenseTemplates: Array<{ id: number, description?: string | null, title: string, denominator?: string | null, type: OfferExpenseTemplateType, minimumProducts?: number | null, price: number, buyPrice: number, locked?: boolean | null, includedByDefault?: boolean | null, automations?: Array<{ condition: string, quantity: number, id: number, quantityCondition?: string | null }> | null }> };

export type DeleteExpenseTemplateMutationVariables = Exact<{
  templateID: Scalars['Int'];
}>;


export type DeleteExpenseTemplateMutation = { deleteExpenseTemplate: boolean };

export type UpsertExpenseTemplateMutationVariables = Exact<{
  template: OfferExpenseTemplateInput;
}>;


export type UpsertExpenseTemplateMutation = { upsertExpenseTemplate: { id: number } };

export type NewOfferExpensesQueryVariables = Exact<{ [key: string]: never; }>;


export type NewOfferExpensesQuery = { newOfferExpenses: { heatPump: Array<{ id: number, description?: string | null, title: string, denominator?: string | null, type: OfferExpenseTemplateType, minimumProducts?: number | null, price: number, buyPrice: number, locked?: boolean | null, includedByDefault?: boolean | null, automations?: Array<{ condition: string, quantity: number, id: number, quantityCondition?: string | null }> | null }>, solar: Array<{ id: number, description?: string | null, title: string, denominator?: string | null, type: OfferExpenseTemplateType, minimumProducts?: number | null, price: number, buyPrice: number, locked?: boolean | null, includedByDefault?: boolean | null, automations?: Array<{ condition: string, quantity: number, id: number, quantityCondition?: string | null }> | null }> } };

export type UploadPublicFileMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadPublicFileMutation = { uploadPublicFile: string };

export type BoxSizeFragment = { height: number, width: number, depth: number };

export type CylinderSizeFragment = { height: number, diameter: number };

export type CompositeFigureFragment = { floor: number, radiator: number };

export type CompositeLabelFragment = { floor: string, radiator: string };

export type OfferExpenseTemplateFragment = { id: number, description?: string | null, title: string, denominator?: string | null, type: OfferExpenseTemplateType, minimumProducts?: number | null, price: number, buyPrice: number, locked?: boolean | null, includedByDefault?: boolean | null, automations?: Array<{ condition: string, quantity: number, id: number, quantityCondition?: string | null }> | null };

export type UserFragment = { id: number, firstName: string, lastName: string, isAdmin: boolean };

export type CurrentUserFragment = { id: number, firstName: string, lastName: string, name: string, email: string, createdAt: number, isAdmin: boolean };

export type HeatPumpIndoorUnitFragment = { id: number, brand: string, model: string, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, noiseLevel: number, datasheetUrl?: string | null, waterVolume: number, buffer: number, power?: string | null, internet: HeatPumpInternet, app: HeatPumpApp, descriptionId?: number | null, solutionType: IndoorUnitSolutionType, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } };

export type HeatPumpOutdoorUnitFragment = { id: number, brand: string, model: string, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, noiseLevel: number, deletedAt?: number | null, temperatureOut: number, compatibleIndoorUnits: Array<number>, datasheetUrl?: string | null, waterLabel: string, copHotWater?: number | null, descriptionId?: number | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number }, scop: { floor: number, radiator: number }, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, energyLabel: { floor: string, radiator: string } };

export type SolarPanelFragment = { id: number, brand: string, model: string, weight: number, annualProduction: number, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, datasheetUrl?: string | null, compatibleInverters: Array<number>, category: PanelCategory, type: PanelType, descriptionId?: number | null, imageUrl?: string | null, notes?: string | null, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, quantity?: number | null, size: { height: number, width: number, depth: number } };

export type InverterFragment = { id: number, brand: string, model: string, weight: number, efficiency: number, capacity: number, warrantyYears: number, compatibleBatteries?: Array<number> | null, datasheetUrl?: string | null, descriptionId?: number | null, imageUrl?: string | null, notes?: string | null, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } };

export type BatteryFragment = { id: number, brand: string, model: string, weight: number, efficiency: number, capacity: number, warrantyYears?: number | null, warrantyCycles?: number | null, datasheetUrl?: string | null, descriptionId?: number | null, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } };

export type AssortedProductFragment = { id: number, brand: string, model: string, descriptionId?: number | null, price: number, buyPrice?: number | null, datasheetUrl?: string | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } };

export type HeatPumpIndoorUnitsQueryVariables = Exact<{
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type HeatPumpIndoorUnitsQuery = { heatPumpIndoorUnits: Array<{ id: number, brand: string, model: string, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, noiseLevel: number, datasheetUrl?: string | null, waterVolume: number, buffer: number, power?: string | null, internet: HeatPumpInternet, app: HeatPumpApp, descriptionId?: number | null, solutionType: IndoorUnitSolutionType, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> };

export type HeatPumpIndoorUnitQueryVariables = Exact<{
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type HeatPumpIndoorUnitQuery = { heatPumpIndoorUnit?: { id: number, brand: string, model: string, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, noiseLevel: number, datasheetUrl?: string | null, waterVolume: number, buffer: number, power?: string | null, internet: HeatPumpInternet, app: HeatPumpApp, descriptionId?: number | null, solutionType: IndoorUnitSolutionType, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null };

export type InsertHeatPumpIndoorUnitMutationVariables = Exact<{
  unit: HeatPumpIndoorUnitInput;
}>;


export type InsertHeatPumpIndoorUnitMutation = { insertHeatPumpIndoorUnit?: { id: number } | null };

export type UpdateHeatPumpIndoorUnitMutationVariables = Exact<{
  unit: HeatPumpIndoorUnitInput;
  id: Scalars['Int'];
}>;


export type UpdateHeatPumpIndoorUnitMutation = { updateHeatPumpIndoorUnit?: { id: number } | null };

export type UpdateHeatPumpIndoorImageMutationVariables = Exact<{
  image: Scalars['Upload'];
  id: Scalars['Int'];
}>;


export type UpdateHeatPumpIndoorImageMutation = { updateHeatPumpIndoorImage: string };

export type HeatPumpOutdoorUnitsQueryVariables = Exact<{
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type HeatPumpOutdoorUnitsQuery = { heatPumpOutdoorUnits: Array<{ id: number, brand: string, model: string, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, noiseLevel: number, deletedAt?: number | null, temperatureOut: number, compatibleIndoorUnits: Array<number>, datasheetUrl?: string | null, waterLabel: string, copHotWater?: number | null, descriptionId?: number | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number }, scop: { floor: number, radiator: number }, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, energyLabel: { floor: string, radiator: string } }> };

export type HeatPumpBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type HeatPumpBrandsQuery = { heatPumpBrands: Array<string> };

export type HeatPumpOutdoorUnitQueryVariables = Exact<{
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type HeatPumpOutdoorUnitQuery = { heatPumpOutdoorUnit?: { id: number, brand: string, model: string, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, noiseLevel: number, deletedAt?: number | null, temperatureOut: number, compatibleIndoorUnits: Array<number>, datasheetUrl?: string | null, waterLabel: string, copHotWater?: number | null, descriptionId?: number | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number }, scop: { floor: number, radiator: number }, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, energyLabel: { floor: string, radiator: string } } | null };

export type InsertHeatPumpOutdoorUnitMutationVariables = Exact<{
  unit: HeatPumpOutdoorUnitInput;
}>;


export type InsertHeatPumpOutdoorUnitMutation = { insertHeatPumpOutdoorUnit?: { id: number } | null };

export type UpdateHeatPumpOutdoorUnitMutationVariables = Exact<{
  unit: HeatPumpOutdoorUnitInput;
  id: Scalars['Int'];
}>;


export type UpdateHeatPumpOutdoorUnitMutation = { updateHeatPumpOutdoorUnit?: { id: number } | null };

export type UpdateHeatPumpOutdoorImageMutationVariables = Exact<{
  image: Scalars['Upload'];
  id: Scalars['Int'];
}>;


export type UpdateHeatPumpOutdoorImageMutation = { updateHeatPumpOutdoorImage: string };

export type HeatPumpPackagesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type HeatPumpPackagesQuery = { heatPumpPackages: Array<{ calculatorEnabled?: boolean | null, discount?: number | null, packageID: number, title?: string | null, webshopEnabled?: boolean | null, indoorUnits?: Array<{ id: number, brand: string, model: string, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, noiseLevel: number, datasheetUrl?: string | null, waterVolume: number, buffer: number, power?: string | null, internet: HeatPumpInternet, app: HeatPumpApp, descriptionId?: number | null, solutionType: IndoorUnitSolutionType, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> | null, outdoorUnits: Array<{ id: number, brand: string, model: string, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, noiseLevel: number, deletedAt?: number | null, temperatureOut: number, compatibleIndoorUnits: Array<number>, datasheetUrl?: string | null, waterLabel: string, copHotWater?: number | null, descriptionId?: number | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number }, scop: { floor: number, radiator: number }, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, energyLabel: { floor: string, radiator: string } }> }> };

export type CreateHeatPumpPackageMutationVariables = Exact<{
  heatPumpPackageInput: HeatPumpPackageInput;
}>;


export type CreateHeatPumpPackageMutation = { createHeatPumpPackage: { packageID: number } };

export type UpdateHeatPumpPackageMutationVariables = Exact<{
  id: Scalars['Int'];
  heatPumpPackageInput: HeatPumpPackageInput;
}>;


export type UpdateHeatPumpPackageMutation = { updateHeatPumpPackage: { packageID: number } };

export type DeleteHeatPumpPackageMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteHeatPumpPackageMutation = { deleteHeatPumpPackage: boolean };

export type InvertersQueryVariables = Exact<{
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type InvertersQuery = { inverters: Array<{ id: number, brand: string, model: string, weight: number, efficiency: number, capacity: number, warrantyYears: number, compatibleBatteries?: Array<number> | null, datasheetUrl?: string | null, descriptionId?: number | null, imageUrl?: string | null, notes?: string | null, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> };

export type InverterBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type InverterBrandsQuery = { inverterBrands: Array<string> };

export type InverterQueryVariables = Exact<{
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type InverterQuery = { inverter?: { id: number, brand: string, model: string, weight: number, efficiency: number, capacity: number, warrantyYears: number, compatibleBatteries?: Array<number> | null, datasheetUrl?: string | null, descriptionId?: number | null, imageUrl?: string | null, notes?: string | null, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null };

export type InsertInverterMutationVariables = Exact<{
  unit: InverterInput;
}>;


export type InsertInverterMutation = { insertInverter?: { id: number } | null };

export type UpdateInverterMutationVariables = Exact<{
  unit: InverterInput;
  id: Scalars['Int'];
}>;


export type UpdateInverterMutation = { updateInverter?: { id: number } | null };

export type UpdateInverterImageMutationVariables = Exact<{
  image: Scalars['Upload'];
  id: Scalars['Int'];
}>;


export type UpdateInverterImageMutation = { updateInverterImage: string };

export type UploadInverterDatasheetMutationVariables = Exact<{
  file: Scalars['Upload'];
  id: Scalars['Int'];
}>;


export type UploadInverterDatasheetMutation = { uploadInverterDatasheet: boolean };

export type UploadSolarPanelDatasheetMutationVariables = Exact<{
  file: Scalars['Upload'];
  id: Scalars['Int'];
}>;


export type UploadSolarPanelDatasheetMutation = { uploadSolarPanelDatasheet: boolean };

export type UploadBatteryDatasheetMutationVariables = Exact<{
  file: Scalars['Upload'];
  id: Scalars['Int'];
}>;


export type UploadBatteryDatasheetMutation = { uploadBatteryDatasheet: boolean };

export type UploadHeatPumpIndoorUnitDatasheetMutationVariables = Exact<{
  file: Scalars['Upload'];
  id: Scalars['Int'];
}>;


export type UploadHeatPumpIndoorUnitDatasheetMutation = { uploadHeatPumpIndoorUnitDatasheet: boolean };

export type UploadHeatPumpOutdoorUnitDatasheetMutationVariables = Exact<{
  file: Scalars['Upload'];
  id: Scalars['Int'];
}>;


export type UploadHeatPumpOutdoorUnitDatasheetMutation = { uploadHeatPumpOutdoorUnitDatasheet: boolean };

export type UploadAssortedProductDatasheetMutationVariables = Exact<{
  file: Scalars['Upload'];
  id: Scalars['Int'];
}>;


export type UploadAssortedProductDatasheetMutation = { uploadAssortedProductDatasheet: boolean };

export type FetchProductDescriptionsQueryVariables = Exact<{
  type: OfferProductType;
}>;


export type FetchProductDescriptionsQuery = { productDescriptions: Array<{ id: number, type: OfferProductType, title: string, content: string }> };

export type CreateProductDescriptionMutationVariables = Exact<{
  description: ProductDescriptionInput;
}>;


export type CreateProductDescriptionMutation = { createProductDescription: { id: number } };

export type UpdateProductDescriptionMutationVariables = Exact<{
  id: Scalars['Int'];
  description: ProductDescriptionInput;
}>;


export type UpdateProductDescriptionMutation = { updateProductDescription: { id: number } };

export type DeleteProductDescriptionMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteProductDescriptionMutation = { deleteProductDescription: boolean };

export type SolarPanelsQueryVariables = Exact<{
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type SolarPanelsQuery = { solarPanels: Array<{ id: number, brand: string, model: string, weight: number, annualProduction: number, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, datasheetUrl?: string | null, compatibleInverters: Array<number>, category: PanelCategory, type: PanelType, descriptionId?: number | null, imageUrl?: string | null, notes?: string | null, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, quantity?: number | null, size: { height: number, width: number, depth: number } }> };

export type SolarPanelBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type SolarPanelBrandsQuery = { solarPanelBrands: Array<string> };

export type SolarPanelQueryVariables = Exact<{
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type SolarPanelQuery = { solarPanel?: { id: number, brand: string, model: string, weight: number, annualProduction: number, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, datasheetUrl?: string | null, compatibleInverters: Array<number>, category: PanelCategory, type: PanelType, descriptionId?: number | null, imageUrl?: string | null, notes?: string | null, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, quantity?: number | null, size: { height: number, width: number, depth: number } } | null };

export type InsertSolarPanelMutationVariables = Exact<{
  unit: SolarPanelInput;
}>;


export type InsertSolarPanelMutation = { insertSolarPanel?: { id: number } | null };

export type UpdateSolarPanelMutationVariables = Exact<{
  unit: SolarPanelInput;
  id: Scalars['Int'];
}>;


export type UpdateSolarPanelMutation = { updateSolarPanel?: { id: number } | null };

export type UpdateSolarPanelImageMutationVariables = Exact<{
  image: Scalars['Upload'];
  id: Scalars['Int'];
}>;


export type UpdateSolarPanelImageMutation = { updateSolarPanelImage: string };

export type SolarProductPackagesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type SolarProductPackagesQuery = { solarProductPackages: Array<{ batteryRangeID?: number | null, calculatorEnabled?: boolean | null, defaultBatteryID?: number | null, discount?: number | null, discountWithoutInstallation?: number | null, packageID: number, title?: string | null, webshopEnabled?: boolean | null, solarPanel: { id: number, brand: string, model: string, weight: number, annualProduction: number, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, datasheetUrl?: string | null, compatibleInverters: Array<number>, category: PanelCategory, type: PanelType, descriptionId?: number | null, imageUrl?: string | null, notes?: string | null, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, quantity?: number | null, size: { height: number, width: number, depth: number } }, batteries?: Array<{ id: number, brand: string, model: string, weight: number, efficiency: number, capacity: number, warrantyYears?: number | null, warrantyCycles?: number | null, datasheetUrl?: string | null, descriptionId?: number | null, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> | null, inverter: { id: number, brand: string, model: string, weight: number, efficiency: number, capacity: number, warrantyYears: number, compatibleBatteries?: Array<number> | null, datasheetUrl?: string | null, descriptionId?: number | null, imageUrl?: string | null, notes?: string | null, price: number, buyPrice?: number | null, enabled?: boolean | null, customerEnabled?: boolean | null, webshopEnabled?: boolean | null, preferred?: boolean | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } }> };

export type CreateSolarProductPackageMutationVariables = Exact<{
  solarPackageInput: SolarProductPackageInput;
}>;


export type CreateSolarProductPackageMutation = { createSolarProductPackage?: { packageID: number } | null };

export type UpdateSolarProductPackageMutationVariables = Exact<{
  id: Scalars['Int'];
  solarPackageInput: SolarProductPackageInput;
}>;


export type UpdateSolarProductPackageMutation = { updateSolarProductPackage?: { packageID: number } | null };

export type DeleteSolarProductPackageMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteSolarProductPackageMutation = { deleteSolarProductPackage: boolean };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { me: { id: number, firstName: string, lastName: string, name: string, email: string, createdAt: number, isAdmin: boolean } };

export type SyncProductsWithWebshopMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncProductsWithWebshopMutation = { syncProductsWithWebshop: boolean };

export const ConstantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Constant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Constant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"valueNumber"}},{"kind":"Field","name":{"kind":"Name","value":"numerator"}},{"kind":"Field","name":{"kind":"Name","value":"denominator"}}]}}]} as unknown as DocumentNode<ConstantFragment, unknown>;
export const OfferExpenseTemplateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfferExpenseTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferExpenseTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"denominator"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"minimumProducts"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"includedByDefault"}},{"kind":"Field","name":{"kind":"Name","value":"automations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantityCondition"}}]}}]}}]} as unknown as DocumentNode<OfferExpenseTemplateFragment, unknown>;
export const UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}}]} as unknown as DocumentNode<UserFragment, unknown>;
export const CurrentUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}}]} as unknown as DocumentNode<CurrentUserFragment, unknown>;
export const BoxSizeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxSize"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}}]}}]} as unknown as DocumentNode<BoxSizeFragment, unknown>;
export const CylinderSizeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CylinderSize"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CylinderSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"diameter"}}]}}]} as unknown as DocumentNode<CylinderSizeFragment, unknown>;
export const HeatPumpIndoorUnitFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HeatPumpIndoorUnit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeatPumpIndoorUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"customerEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"webshopEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"noiseLevel"}},{"kind":"Field","name":{"kind":"Name","value":"datasheetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"waterVolume"}},{"kind":"Field","name":{"kind":"Name","value":"buffer"}},{"kind":"Field","name":{"kind":"Name","value":"power"}},{"kind":"Field","name":{"kind":"Name","value":"internet"}},{"kind":"Field","name":{"kind":"Name","value":"app"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"solutionType"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxSize"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CylinderSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CylinderSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]} as unknown as DocumentNode<HeatPumpIndoorUnitFragment, unknown>;
export const CompositeFigureFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompositeFigure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompositeFigure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"floor"}},{"kind":"Field","name":{"kind":"Name","value":"radiator"}}]}}]} as unknown as DocumentNode<CompositeFigureFragment, unknown>;
export const CompositeLabelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompositeLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompositeLabel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"floor"}},{"kind":"Field","name":{"kind":"Name","value":"radiator"}}]}}]} as unknown as DocumentNode<CompositeLabelFragment, unknown>;
export const HeatPumpOutdoorUnitFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HeatPumpOutdoorUnit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeatPumpOutdoorUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"customerEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"webshopEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"noiseLevel"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"temperatureOut"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleIndoorUnits"}},{"kind":"Field","name":{"kind":"Name","value":"datasheetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"waterLabel"}},{"kind":"Field","name":{"kind":"Name","value":"copHotWater"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxSize"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CylinderSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CylinderSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"scop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompositeFigure"}}]}},{"kind":"Field","name":{"kind":"Name","value":"effect7"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompositeFigure"}}]}},{"kind":"Field","name":{"kind":"Name","value":"effect12"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompositeFigure"}}]}},{"kind":"Field","name":{"kind":"Name","value":"energyLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompositeLabel"}}]}}]}}]} as unknown as DocumentNode<HeatPumpOutdoorUnitFragment, unknown>;
export const SolarPanelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SolarPanel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SolarPanel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"annualProduction"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"productWarrantyYears"}},{"kind":"Field","name":{"kind":"Name","value":"performanceWarrantyYears"}},{"kind":"Field","name":{"kind":"Name","value":"degradationPerYear"}},{"kind":"Field","name":{"kind":"Name","value":"datasheetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleInverters"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxSize"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"customerEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"webshopEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]} as unknown as DocumentNode<SolarPanelFragment, unknown>;
export const InverterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Inverter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Inverter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"efficiency"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"warrantyYears"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleBatteries"}},{"kind":"Field","name":{"kind":"Name","value":"datasheetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxSize"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CylinderSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CylinderSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"customerEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"webshopEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}}]}}]} as unknown as DocumentNode<InverterFragment, unknown>;
export const BatteryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Battery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Battery"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"efficiency"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"warrantyYears"}},{"kind":"Field","name":{"kind":"Name","value":"warrantyCycles"}},{"kind":"Field","name":{"kind":"Name","value":"datasheetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"customerEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"webshopEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxSize"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CylinderSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CylinderSize"}}]}}]}}]}}]} as unknown as DocumentNode<BatteryFragment, unknown>;
export const AssortedProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssortedProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssortedProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxSize"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CylinderSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CylinderSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"datasheetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]} as unknown as DocumentNode<AssortedProductFragment, unknown>;
export const AssortedProductsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assortedProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortedProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssortedProduct"}}]}}]}},...AssortedProductFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions]} as unknown as DocumentNode<AssortedProductsQuery, AssortedProductsQueryVariables>;
export const AssortedProductBrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assortedProductBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortedProductBrands"}}]}}]} as unknown as DocumentNode<AssortedProductBrandsQuery, AssortedProductBrandsQueryVariables>;
export const AssortedProductDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assortedProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortedProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssortedProduct"}}]}}]}},...AssortedProductFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions]} as unknown as DocumentNode<AssortedProductQuery, AssortedProductQueryVariables>;
export const InsertAssortedProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertAssortedProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssortedProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAssortedProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertAssortedProductMutation, InsertAssortedProductMutationVariables>;
export const UpdateAssortedProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAssortedProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssortedProductInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssortedProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateAssortedProductMutation, UpdateAssortedProductMutationVariables>;
export const UpdateAssortedProductImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAssortedProductImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssortedProductImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"image"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UpdateAssortedProductImageMutation, UpdateAssortedProductImageMutationVariables>;
export const RefreshLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"refreshLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"refreshToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]} as unknown as DocumentNode<RefreshLoginMutation, RefreshLoginMutationVariables>;
export const BatteriesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"batteries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batteries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Battery"}}]}}]}},...BatteryFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions]} as unknown as DocumentNode<BatteriesQuery, BatteriesQueryVariables>;
export const CompatibleBatteriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"compatibleBatteries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batteries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}}]}}]}}]} as unknown as DocumentNode<CompatibleBatteriesQuery, CompatibleBatteriesQueryVariables>;
export const BatteryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"battery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"battery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Battery"}}]}}]}},...BatteryFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions]} as unknown as DocumentNode<BatteryQuery, BatteryQueryVariables>;
export const BatteryBrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"batteryBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batteryBrands"}}]}}]} as unknown as DocumentNode<BatteryBrandsQuery, BatteryBrandsQueryVariables>;
export const InsertBatteryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertBattery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatteryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertBattery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertBatteryMutation, InsertBatteryMutationVariables>;
export const UpdateBatteryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBattery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatteryInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBattery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateBatteryMutation, UpdateBatteryMutationVariables>;
export const UpdateBatteryImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBatteryImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBatteryImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"image"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UpdateBatteryImageMutation, UpdateBatteryImageMutationVariables>;
export const BatteryRangesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"batteryRanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batteryRanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"batteries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Battery"}}]}}]}}]}},...BatteryFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions]} as unknown as DocumentNode<BatteryRangesQuery, BatteryRangesQueryVariables>;
export const CreateBatteryRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBatteryRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"batteryRangeInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatteryRangeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBatteryRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"batteryRangeInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"batteryRangeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateBatteryRangeMutation, CreateBatteryRangeMutationVariables>;
export const UpdateBatteryRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBatteryRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"batteryRangeInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatteryRangeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBatteryRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"batteryRangeInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"batteryRangeInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateBatteryRangeMutation, UpdateBatteryRangeMutationVariables>;
export const DeleteBatteryRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteBatteryRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBatteryRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteBatteryRangeMutation, DeleteBatteryRangeMutationVariables>;
export const UpdateConstantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateConstant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConstantInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConstant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"constant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constant"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<UpdateConstantMutation, UpdateConstantMutationVariables>;
export const ConstantsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"constants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Constant"}}]}}]}},...ConstantFragmentDoc.definitions]} as unknown as DocumentNode<ConstantsQuery, ConstantsQueryVariables>;
export const ExpenseTemplatesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"expenseTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OfferType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expenseTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferExpenseTemplate"}}]}}]}},...OfferExpenseTemplateFragmentDoc.definitions]} as unknown as DocumentNode<ExpenseTemplatesQuery, ExpenseTemplatesQueryVariables>;
export const DeleteExpenseTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteExpenseTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteExpenseTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"templateID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateID"}}}]}]}}]} as unknown as DocumentNode<DeleteExpenseTemplateMutation, DeleteExpenseTemplateMutationVariables>;
export const UpsertExpenseTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertExpenseTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"template"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OfferExpenseTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertExpenseTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"template"},"value":{"kind":"Variable","name":{"kind":"Name","value":"template"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertExpenseTemplateMutation, UpsertExpenseTemplateMutationVariables>;
export const NewOfferExpensesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"newOfferExpenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newOfferExpenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatPump"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferExpenseTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"solar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferExpenseTemplate"}}]}}]}}]}},...OfferExpenseTemplateFragmentDoc.definitions]} as unknown as DocumentNode<NewOfferExpensesQuery, NewOfferExpensesQueryVariables>;
export const UploadPublicFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadPublicFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadPublicFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}]}]}}]} as unknown as DocumentNode<UploadPublicFileMutation, UploadPublicFileMutationVariables>;
export const HeatPumpIndoorUnitsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"heatPumpIndoorUnits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatPumpIndoorUnits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeatPumpIndoorUnit"}}]}}]}},...HeatPumpIndoorUnitFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions]} as unknown as DocumentNode<HeatPumpIndoorUnitsQuery, HeatPumpIndoorUnitsQueryVariables>;
export const HeatPumpIndoorUnitDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"heatPumpIndoorUnit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatPumpIndoorUnit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeatPumpIndoorUnit"}}]}}]}},...HeatPumpIndoorUnitFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions]} as unknown as DocumentNode<HeatPumpIndoorUnitQuery, HeatPumpIndoorUnitQueryVariables>;
export const InsertHeatPumpIndoorUnitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertHeatPumpIndoorUnit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HeatPumpIndoorUnitInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertHeatPumpIndoorUnit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertHeatPumpIndoorUnitMutation, InsertHeatPumpIndoorUnitMutationVariables>;
export const UpdateHeatPumpIndoorUnitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateHeatPumpIndoorUnit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HeatPumpIndoorUnitInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateHeatPumpIndoorUnit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateHeatPumpIndoorUnitMutation, UpdateHeatPumpIndoorUnitMutationVariables>;
export const UpdateHeatPumpIndoorImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateHeatPumpIndoorImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateHeatPumpIndoorImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"image"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UpdateHeatPumpIndoorImageMutation, UpdateHeatPumpIndoorImageMutationVariables>;
export const HeatPumpOutdoorUnitsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"heatPumpOutdoorUnits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatPumpOutdoorUnits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeatPumpOutdoorUnit"}}]}}]}},...HeatPumpOutdoorUnitFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions,...CompositeFigureFragmentDoc.definitions,...CompositeLabelFragmentDoc.definitions]} as unknown as DocumentNode<HeatPumpOutdoorUnitsQuery, HeatPumpOutdoorUnitsQueryVariables>;
export const HeatPumpBrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"heatPumpBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatPumpBrands"}}]}}]} as unknown as DocumentNode<HeatPumpBrandsQuery, HeatPumpBrandsQueryVariables>;
export const HeatPumpOutdoorUnitDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"heatPumpOutdoorUnit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatPumpOutdoorUnit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeatPumpOutdoorUnit"}}]}}]}},...HeatPumpOutdoorUnitFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions,...CompositeFigureFragmentDoc.definitions,...CompositeLabelFragmentDoc.definitions]} as unknown as DocumentNode<HeatPumpOutdoorUnitQuery, HeatPumpOutdoorUnitQueryVariables>;
export const InsertHeatPumpOutdoorUnitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertHeatPumpOutdoorUnit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HeatPumpOutdoorUnitInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertHeatPumpOutdoorUnit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertHeatPumpOutdoorUnitMutation, InsertHeatPumpOutdoorUnitMutationVariables>;
export const UpdateHeatPumpOutdoorUnitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateHeatPumpOutdoorUnit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HeatPumpOutdoorUnitInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateHeatPumpOutdoorUnit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateHeatPumpOutdoorUnitMutation, UpdateHeatPumpOutdoorUnitMutationVariables>;
export const UpdateHeatPumpOutdoorImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateHeatPumpOutdoorImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateHeatPumpOutdoorImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"image"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UpdateHeatPumpOutdoorImageMutation, UpdateHeatPumpOutdoorImageMutationVariables>;
export const HeatPumpPackagesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"heatPumpPackages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatPumpPackages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatorEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"indoorUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeatPumpIndoorUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outdoorUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeatPumpOutdoorUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packageID"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"webshopEnabled"}}]}}]}},...HeatPumpIndoorUnitFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions,...HeatPumpOutdoorUnitFragmentDoc.definitions,...CompositeFigureFragmentDoc.definitions,...CompositeLabelFragmentDoc.definitions]} as unknown as DocumentNode<HeatPumpPackagesQuery, HeatPumpPackagesQueryVariables>;
export const CreateHeatPumpPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createHeatPumpPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"heatPumpPackageInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HeatPumpPackageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createHeatPumpPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"heatPumpPackageInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"heatPumpPackageInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packageID"}}]}}]}}]} as unknown as DocumentNode<CreateHeatPumpPackageMutation, CreateHeatPumpPackageMutationVariables>;
export const UpdateHeatPumpPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateHeatPumpPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"heatPumpPackageInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HeatPumpPackageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateHeatPumpPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"heatPumpPackageInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"heatPumpPackageInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packageID"}}]}}]}}]} as unknown as DocumentNode<UpdateHeatPumpPackageMutation, UpdateHeatPumpPackageMutationVariables>;
export const DeleteHeatPumpPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteHeatPumpPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteHeatPumpPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteHeatPumpPackageMutation, DeleteHeatPumpPackageMutationVariables>;
export const InvertersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"inverters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inverters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Inverter"}}]}}]}},...InverterFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions]} as unknown as DocumentNode<InvertersQuery, InvertersQueryVariables>;
export const InverterBrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"inverterBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inverterBrands"}}]}}]} as unknown as DocumentNode<InverterBrandsQuery, InverterBrandsQueryVariables>;
export const InverterDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"inverter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inverter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Inverter"}}]}}]}},...InverterFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions]} as unknown as DocumentNode<InverterQuery, InverterQueryVariables>;
export const InsertInverterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertInverter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InverterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertInverter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertInverterMutation, InsertInverterMutationVariables>;
export const UpdateInverterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateInverter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InverterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInverter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateInverterMutation, UpdateInverterMutationVariables>;
export const UpdateInverterImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateInverterImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInverterImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"image"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UpdateInverterImageMutation, UpdateInverterImageMutationVariables>;
export const UploadInverterDatasheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadInverterDatasheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadInverterDatasheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasheet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UploadInverterDatasheetMutation, UploadInverterDatasheetMutationVariables>;
export const UploadSolarPanelDatasheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadSolarPanelDatasheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadSolarPanelDatasheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasheet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UploadSolarPanelDatasheetMutation, UploadSolarPanelDatasheetMutationVariables>;
export const UploadBatteryDatasheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadBatteryDatasheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadBatteryDatasheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasheet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UploadBatteryDatasheetMutation, UploadBatteryDatasheetMutationVariables>;
export const UploadHeatPumpIndoorUnitDatasheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadHeatPumpIndoorUnitDatasheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadHeatPumpIndoorUnitDatasheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasheet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UploadHeatPumpIndoorUnitDatasheetMutation, UploadHeatPumpIndoorUnitDatasheetMutationVariables>;
export const UploadHeatPumpOutdoorUnitDatasheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadHeatPumpOutdoorUnitDatasheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadHeatPumpOutdoorUnitDatasheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasheet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UploadHeatPumpOutdoorUnitDatasheetMutation, UploadHeatPumpOutdoorUnitDatasheetMutationVariables>;
export const UploadAssortedProductDatasheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadAssortedProductDatasheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadAssortedProductDatasheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datasheet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UploadAssortedProductDatasheetMutation, UploadAssortedProductDatasheetMutationVariables>;
export const FetchProductDescriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchProductDescriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OfferProductType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productDescriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<FetchProductDescriptionsQuery, FetchProductDescriptionsQueryVariables>;
export const CreateProductDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProductDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDescriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProductDescription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateProductDescriptionMutation, CreateProductDescriptionMutationVariables>;
export const UpdateProductDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProductDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDescriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductDescription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateProductDescriptionMutation, UpdateProductDescriptionMutationVariables>;
export const DeleteProductDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteProductDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProductDescription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteProductDescriptionMutation, DeleteProductDescriptionMutationVariables>;
export const SolarPanelsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"solarPanels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"solarPanels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SolarPanel"}}]}}]}},...SolarPanelFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions]} as unknown as DocumentNode<SolarPanelsQuery, SolarPanelsQueryVariables>;
export const SolarPanelBrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"solarPanelBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"solarPanelBrands"}}]}}]} as unknown as DocumentNode<SolarPanelBrandsQuery, SolarPanelBrandsQueryVariables>;
export const SolarPanelDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"solarPanel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"solarPanel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SolarPanel"}}]}}]}},...SolarPanelFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions]} as unknown as DocumentNode<SolarPanelQuery, SolarPanelQueryVariables>;
export const InsertSolarPanelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertSolarPanel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SolarPanelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertSolarPanel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertSolarPanelMutation, InsertSolarPanelMutationVariables>;
export const UpdateSolarPanelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSolarPanel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SolarPanelInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSolarPanel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateSolarPanelMutation, UpdateSolarPanelMutationVariables>;
export const UpdateSolarPanelImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSolarPanelImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSolarPanelImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"image"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UpdateSolarPanelImageMutation, UpdateSolarPanelImageMutationVariables>;
export const SolarProductPackagesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"solarProductPackages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"solarProductPackages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"isAdvisor"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batteryRangeID"}},{"kind":"Field","name":{"kind":"Name","value":"calculatorEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"defaultBatteryID"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"discountWithoutInstallation"}},{"kind":"Field","name":{"kind":"Name","value":"packageID"}},{"kind":"Field","name":{"kind":"Name","value":"solarPanel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SolarPanel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batteries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Battery"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inverter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Inverter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"webshopEnabled"}}]}}]}},...SolarPanelFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...BatteryFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions,...InverterFragmentDoc.definitions]} as unknown as DocumentNode<SolarProductPackagesQuery, SolarProductPackagesQueryVariables>;
export const CreateSolarProductPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSolarProductPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"solarPackageInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SolarProductPackageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSolarProductPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"solarPackageInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"solarPackageInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packageID"}}]}}]}}]} as unknown as DocumentNode<CreateSolarProductPackageMutation, CreateSolarProductPackageMutationVariables>;
export const UpdateSolarProductPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSolarProductPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"solarPackageInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SolarProductPackageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSolarProductPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"solarPackageInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"solarPackageInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packageID"}}]}}]}}]} as unknown as DocumentNode<UpdateSolarProductPackageMutation, UpdateSolarProductPackageMutationVariables>;
export const DeleteSolarProductPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteSolarProductPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSolarProductPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteSolarProductPackageMutation, DeleteSolarProductPackageMutationVariables>;
export const CurrentUserDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentUser"}}]}}]}},...CurrentUserFragmentDoc.definitions]} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const SyncProductsWithWebshopDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"syncProductsWithWebshop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncProductsWithWebshop"}}]}}]} as unknown as DocumentNode<SyncProductsWithWebshopMutation, SyncProductsWithWebshopMutationVariables>;